import { Row, Col } from 'reactstrap';
import { MdOutlineCheckCircleOutline } from 'react-icons/md';

const WhyUs = () => {
    return (
        <Row className='my-5'>
            <Col xs='12' sm='12' md='6' lg='6'>
                <img src="/Assets/feedback.jpg" className='img-thumbnail img-fluid rounded' width='100%' height='100%' alt="" />
            </Col>
            <Col xs='12' sm='12' md='6' lg='6'>
                <h1>Why Should Choose Us?</h1>
                <p>Basically, finding the right person to do up the works is very much important and for that, there are certain things you should keep in mind while appointing a service man. Analyze the best service provider who can perform the works well and give you desired results. You can search for professional home service companies online and get the best company that meets up your demands.</p>
                <h5><MdOutlineCheckCircleOutline /> AC Cleaning</h5>
                <h5><MdOutlineCheckCircleOutline /> AC Service</h5>
                <h5><MdOutlineCheckCircleOutline /> AC Repairing</h5>
                <h5><MdOutlineCheckCircleOutline /> Painting</h5>
            </Col>
        </Row>
    );
};

export default WhyUs;